import React from 'react';

/**
 * Connect + import controls, one row per broker returned by /api/brokers/status.
 * Labels and notes come from the server so adding a broker needs no client change.
 */
function BrokerSyncPanel({ brokers, disabled, importingBrokerId, onConnect, onImport, message }) {
  const available = (brokers || []).filter((b) => b.configured);
  if (!available.length) return null;

  return (
    <div className="broker-sync-panel">
      {available.map((b) => (
        <div key={b.id} className="broker-sync__broker">
          <div className="broker-sync__actions">
            <button
              type="button"
              className={`btn ${b.connected ? 'btn-secondary' : 'btn-primary'}`}
              onClick={() => onConnect(b.id)}
              disabled={disabled || b.connected}
              title={b.connected ? `${b.label} session is already valid` : `Authorize ${b.label}`}
            >
              Connect {b.label}
            </button>
            <button
              type="button"
              className={`btn ${b.connected ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => onImport(b.id)}
              disabled={disabled || !b.connected}
              title={!b.connected ? `Connect ${b.label} first` : `Fetch today's fills from ${b.label}`}
            >
              {importingBrokerId === b.id ? 'Importing…' : `Import today's fills from ${b.label}`}
            </button>
          </div>
          {b.note && <p className="broker-sync__note">{b.note}</p>}
          {b.sessionExpired && (
            <div className="warning-message broker-sync__under-import" role="status">
              Your saved {b.label} session has expired. Connect again before importing.
            </div>
          )}
        </div>
      ))}
      {message && (
        <div className="success-message broker-sync__under-import" role="status">
          {message}
        </div>
      )}
    </div>
  );
}

export default BrokerSyncPanel;
